import { discountInfoSchema } from "./discountInfoSchema";
import { z } from "zod";

export const discountsResponseSchema = z.lazy(() => discountInfoSchema);

export type DiscountsResponse = z.infer<typeof discountsResponseSchema>;
